<template>
  <div id="wrapper">
    <h1>{{ $t("marinConstantin.archive.title") }}</h1>
    <Loading v-if="!data" />
    <div v-if="data" v-masonry transition-duration="0.3s" item-selector=".item">
      <img
        v-masonry-tile
        class="item"
        v-for="item in data"
        :src="item.thumbnail"
        :key="item.thumbnail"
      />
    </div>
  </div>
</template>

<script>
import Loading from "../Loading";

export default {
  name: "MCArchive",
  components: { Loading },
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.$http
      .get("marin-constantin/archive/")
      .then(response => (this.data = response.data));
  }
};
</script>

<style scoped>
#wrapper {
  padding: 10vh 0;
}

.item {
  padding: 10px;
  width: 25%;
}

@media (max-width: 767px) {
  .item {
    width: 50%;
  }
}

@media (max-width: 479px) {
  .item {
    width: 100%;
  }
}

h1 {
  margin-bottom: 7vh;
  text-transform: uppercase;
  text-align: center;
  color: #19242c;
  font-size: 3.2em;
}
</style>
